import { render, staticRenderFns } from "./AddonTicketmaster.vue?vue&type=template&id=831130ca&scoped=true&"
import script from "./AddonTicketmaster.vue?vue&type=script&lang=js&"
export * from "./AddonTicketmaster.vue?vue&type=script&lang=js&"
import style0 from "./AddonTicketmaster.vue?vue&type=style&index=0&id=831130ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831130ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
